import Navbar from '../components/Home/Navbar';
import Banner from '../components/Home/Banner';
import Services from '../components/Home/Services';
import About from '../components/Home/About';
import Contact from '../components/Home/Contact';
import Footer from '../components/Home/Footer';

const Home = () => {
	return (
		<header>
			<Navbar />
			<Banner />
			<Services />
			<About />
			<Contact />
			<Footer />
		</header>
	);
};

export default Home;
